/**
 * Ticket Z14: Layout-Route für die Druckadresse /100-tage.
 *
 * WICHTIG: Diese Adresse steht in gedruckten Materialien und in einem QR-Code.
 * Sie darf nicht entfernt oder umbenannt werden. Eine spätere Umlenkung läuft
 * ausschließlich über das Feld „Weiterleitungsziel" im Pflegeformular, das in
 * die zentrale Weiterleitungsliste schreibt und dort vor dem Rendern
 * ausgewertet wird (siehe src/server.ts).
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/100-tage")({
  component: () => <Outlet />,
});
